import { render, staticRenderFns } from "./food.vue?vue&type=template&id=6fe86271&scoped=true"
import script from "./food.vue?vue&type=script&lang=js"
export * from "./food.vue?vue&type=script&lang=js"
import style0 from "./food.vue?vue&type=style&index=0&id=6fe86271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe86271",
  null
  
)

export default component.exports